export default __webpack_public_path__ + "static/media/alert-icon.59751661.svg";